document.addEventListener('DOMContentLoaded', function() {
    var grid = document.querySelector('.post-filter-grid');
    if (!grid) return;
    var pagination = document.querySelector('.pagination'); // adjust if needed

    var iso = new Isotope(grid, {
        itemSelector: '.post-item',
        percentPosition: true,
        layoutMode: 'fitRows'
    });

    var filterButtons = document.querySelectorAll('.filter-button');
    var postsPerPage = 6; // adjust to match WP query

    // Helper: show/hide pagination based on visible items
    function updatePagination() {
        var visibleItems = grid.querySelectorAll('.post-item:not([style*="display: none"])');
        if (!pagination) return;

        if (visibleItems.length <= postsPerPage) {
            pagination.style.display = 'none';
        } else {
            pagination.style.display = '';
        }
    }

    // Initial check
    updatePagination();

    // Filter buttons
    filterButtons.forEach(function(btn) {
        btn.addEventListener('click', function(e) {
            e.preventDefault();
            var filterValue = this.getAttribute('data-filter');

            // Filter Isotope
            iso.arrange({ filter: filterValue });

            // Update active class
            filterButtons.forEach(b => b.classList.remove('active'));
            this.classList.add('active');

            // Update URL hash and remove any /page/x/ from URL
            var filterSlug = filterValue === '*' ? '' : filterValue.replace('.', '');
            var url = window.location.href;

            // Remove /page/x/ using regex
            url = url.replace(/\/page\/\d+\//, '/');

            // Update URL with hash
            if (filterSlug) {
                history.replaceState(null, '', url.split('#')[0] + '#' + filterSlug);
            } else {
                history.replaceState(null, '', url.split('#')[0]);
            }

            // Run after Isotope finishes
            iso.once('arrangeComplete', updatePagination);
        });
    });

    // Apply filter from hash on page load
    if (location.hash) {
        var hashFilter = '.' + location.hash.substring(1);
        iso.arrange({ filter: hashFilter });

        filterButtons.forEach(b => b.classList.remove('active'));
        var activeBtn = Array.from(filterButtons).find(b => b.getAttribute('data-filter') === hashFilter);
        if (activeBtn) activeBtn.classList.add('active');

        iso.once('arrangeComplete', updatePagination);
    }
});